import { useEffect, useRef, memo } from 'react';

function TradingViewWidget({ symbol }) {
  const container = useRef();

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-symbol-overview.js';
    script.type = 'text/javascript';
    script.async = true;

    script.innerHTML = `
    {
      "symbols": [
        ["${symbol}"]
      ],
      "chartOnly": false,
      "width": "100%",
      "height": "750",
      "locale": "en",
      "colorTheme": "dark",
      "maLineColor": "#2962FF",
      "maLineWidth": 1,
      "maLength": 365,
      "showMA": true,
      "valuesTracking": "1"
    }`;

    container.current.innerHTML = ''; // Clear previous widget content
    container.current.appendChild(script);
  }, [symbol]); // Re-run the effect when the symbol changes

  return (
    <div className="tradingview-widget-container" ref={container}>
      <div className="tradingview-widget-container__widget"></div>
      <div className="tradingview-widget-copyright">
        <a href="https://www.tradingview.com/" rel="noopener nofollow" target="_blank">
          <span className="blue-text">Track all markets on TradingView</span>
        </a>
      </div>
    </div>
  );
}

export default memo(TradingViewWidget);
